<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-modal no-close-on-backdrop size="xl" id="create" hide-footer>
      <template v-slot:modal-title>CADASTRAR DE SERVIÇO</template>
      <Create @success="paginate" :serviceChargeTypes="serviceChargeTypes" />
    </b-modal>
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">SERVIÇOS</h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'service')"
              class="btn-add ml-2"
              v-on:click="handleModalCreate"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Pesquisar serviços"
              outlined
              dense
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="data.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="data.length > 0"
          v-if="permission('read', 'service')"
          dense
          :headers="headers"
          :items="data"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.sale_price`]="{ item }"
            >{{ formatPrice(item.sale_price) }}
            <b-modal
              no-close-on-backdrop
              size="xl"
              :id="`edit_${String(item.id)}`"
              hide-footer
            >
              <template v-slot:modal-title>EDITAR SERVIÇO</template>
              <Edit
                @success="paginate"
                :item="item"
                :serviceChargeTypes="serviceChargeTypes"
                :finance_configuration_category="finance_configuration_category"
              />
            </b-modal>
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Create from "../templates/Service/create";
import Edit from "../templates/Service/edit";

import routes from "../routes";

import api from "../services/api";

import permission from "../lib/permission";

import { formatPrice } from "../lib/format";

export default {
  name: "Services",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Create,
    Edit,
  },

  data() {
    return {
      search: "",
      headers: [
        { text: "Tipo de cobrança", value: "service_charge_type_name" },
        { text: "Descrição", value: "description" },
        { text: "Valor da venda", value: "sale_price" },
      ],
      data: [],
      serviceChargeTypes: [],
      finance_configuration_category: [],
      id: "",
      width: window.screen.width,
      loading: true,
      errors: [],
    };
  },

  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    permission,
    formatPrice,

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleToBack: () => routes.go(-1),

    handleModalCreate() {
      this.$bvModal.show("create");
    },

    handleClickRowTable(item) {
      this.id = item.id;
      this.$bvModal.show(`edit_${String(item.id)}`);
    },

    async retrieve() {
      if (permission("read", "financial")) {
        this.headers.splice(2, 0, {
          text: "CATEGORIA DO FINANCEIRO",
          value: "finance_configuration_category_name",
        });
      }

      await this.paginate();
      await this.getServiceChargeTypes();
      await this.financeConfigurationCategory();
    },

    async paginate() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = services;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getServiceChargeTypes() {
      try {
        const response = await api.get("/rest-home/service-charge-type/all");

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.serviceChargeTypes = types;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
